import { gql } from '@apollo/client';

const LeadershipQueryEn = gql`
  query MyQuery {
    nodeLeaderships(first: 100, langcode: "en") {
      nodes {
        id
        path
        post
        shortDescription
        title
        commonBanner {
          ... on MediaCommonBanner {
            id
            name
            mediaImage2 {
            url
            alt
          }
          }
        }
        imageAbout {
          url
          alt
        }
        group {
          ... on TermPost {
            id
            name
          }
        }
        body {
          value
        }
      }
    }
  }
`;

export default LeadershipQueryEn;
